export const NEXT_DYNAMIC_ROUTE_PARAM_1 = 'param1';
export const NEXT_DYNAMIC_ROUTE_PARAM_2 = 'param2';
